import { $request } from '@/utils/request';
import servers from '../servers';

/**
 * @description: 首页-列表
 */
export function getList(params?: any): any {
  return $request({
    url: `${servers.api}/v1/statement/search/list`,
    method: 'POST',
    data: params,
  });
}

/**
 * @description: 首页-收藏
 */
export function updateStar(params?: any): any {
  return $request({
    url: `${servers.api}/v1/statement/collect`,
    method: 'POST',
    data: params,
  });
}

/**
 * @description: 首页-取消收藏
 */
export function deleteStar(param: any): any {
  return $request({
    url: `${servers.api}/v1/statement/del/${param}`,
    method: 'GET',
    data: param,
  });
}

/**
 * @description: 首页-访问报表记录
 */
export function visitingRecord(param: any): any {
  return $request({
    url: `${servers.api}/v1/statement/visitingRecord`,
    method: 'POST',
    data: param,
  });
}

/**
 * @description: 首页-获取主题树
 */
export function getSubjectTree() {
  return $request({
    url: `${servers.api}/v1/statement/subject/tree`,
    method: 'GET',
  });
}

/**
 * @description: 首页-获取报表指标信息
 */
export function getAssetStatement(param: any): any {
  return $request({
    url: `${servers.api}/v1/statement/index/list/${param}`,
    method: 'GET',
    data: param,
  });
}

/**
 * @description: 首页-我的需求
 */
export function demandList() {
  return $request({
    url: `${servers.api}/v1/requirement/list/me`,
    method: 'GET',
  });
}

/**
 * @description: 首页-公告栏
 */
export function getboard() {
  return $request({
    url: `${servers.api}/v1/system/board`,
    method: 'GET',
  });
}

/**
 * @description: 首页-我的申请
 */
export function getBpmList(param: any) {
  return $request({
    url: `${servers.api}/v1/bpm/list`,
    method: 'POST',
    data: param,
  });
}

/**
 * @description: 首页-我的申请 查看全部
 */
export function getBpmListAll(param: any) {
  return $request({
    url: `${servers.api}/v1/bpm/list/all`,
    method: 'POST',
    data: param,
  });
}

/**
 * @description: 首页-我的申请 【报表下载】查询审批流业务信息
 */
export function getBpmStatementDownload(param: any) {
  return $request({
    url: `${servers.api}/v1/bpm/statementDownload/${param}/detail`,
    method: 'get',
    data: param,
  });
}

/**
 * @description: 首页快速咨询 排班人员
 */
export function getPersonOnDuty() {
  return $request({
    url: `${servers.api}/v1/system/duty`,
    method: 'get',
  });
}

